import { BaseEnum } from 'services/enums/baseEnum';

const listsEnum: Array<RecruitmentCustomFieldInputType> = [];

export class RecruitmentCustomFieldInputType extends BaseEnum {
  static SELECT = new RecruitmentCustomFieldInputType(
    2,
    'SELECT',
    'Caixa de seleção',
    'circle',
    'Campo para seleção de uma opção em uma lista suspensa.'
  );
  static MULTISELECT = new RecruitmentCustomFieldInputType(
    3,
    'MULTISELECT',
    'Caixa de seleção múltipla',
    'circle',
    'Campo para seleção de várias opções entre várias em uma lista suspensa.'
  );

  static TEXTAREA = new RecruitmentCustomFieldInputType(
    4,
    'TEXTAREA',
    'Resposta longa',
    'align-justify',
    'Campo para respostas longas em texto livre.'
  );
  static TEXT = new RecruitmentCustomFieldInputType(
    5,
    'TEXT',
    'Resposta curta',
    'type',
    'Campo para respostas curtas em texto livre.'
  );

  static DATE = new RecruitmentCustomFieldInputType(
    6,
    'DATE',
    'Data',
    'calendar',
    'Campo para seleção de data.'
  );

  static RADIO_OPTION = new RecruitmentCustomFieldInputType(
    1,
    'RADIO_OPTION',
    'Seleção simples',
    'list',
    'Campo para seleção de uma única opção entre várias.'
  );
  static RADIO_OPTION_MULTISELECT = new RecruitmentCustomFieldInputType(
    8,
    'RADIO_OPTION_MULTISELECT',
    'Seleção múltipla',
    'list',
    'Campo para seleção de várias opções entre várias.'
  );
  static TRUE_OR_FALSE = new RecruitmentCustomFieldInputType(
    7,
    'TRUE_OR_FALSE',
    'Seleção verdadeira ou falsa',
    'check-square',
    'Campo para seleção de verdadeiro ou falso.'
  );
  static FILE = new RecruitmentCustomFieldInputType(
    9,
    'FILE',
    'Arquivo',
    'upload-cloud',
    'Campo para upload de arquivos.'
  );
  static NUMERIC = new RecruitmentCustomFieldInputType(
    10,
    'NUMERIC',
    'Numérico',
    'hash',
    'Campo numérico com máscara monetária.'
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public icon: string,
    public description: string
  ) {
    super(id, value, label, icon);
    listsEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listsEnum;
  }
}
